<template>
  <section class="w-100 bg-light m-h-100">
    <b-container class="m-h-100">
      <b-row class="m-h-100 padding-section">
        <b-col lg="6" class="d-flex justify-content-center flex-column bg-white order-2">
          <h1
            class="font-weight-normal text-purple mb-3 mt-3"
            v-html="'Qual o perfil de um franqueado <strong>VAAPTY Auto Trader</strong>.'"
          />

          <div clss="text-secondary">
            <p class="mb-3 text-purple">
              <strong>É empreendedor</strong> e enxerga esta grande
              <strong>oportunidade</strong> no setor
            </p>
            <p class="mb-3 text-purple">
              <strong>É inovador!</strong> Você já se imaginou vendendo carro em 40 minutos?!
            </p>
            <p class="mb-3 text-purple">
              Tem
              <strong>habilidade e empatia</strong> com vendas de automóveis.
            </p>
            <p class="mb-3 text-purple">
              É um profissional que está
              <strong>buscando mudar a sua vida</strong> com uma proposta inovadora jamais vista.
            </p>
            <p class="mb-5 text-purple">
              Quem busca a maior
              <strong>rentabilidade sobre seu capital.</strong>
            </p>

            <b-button
              variant="purple"
              v-html="'Comece agora'"
              class="text-uppercase text-white px-5 py-2 my-3 btn-comece-agora"
              @click="scrollTo('#form-brookers')"
            />
          </div>
        </b-col>

        <b-col lg="6" class="bg-perfil d-none d-lg-inline-block d-xl-inline-block" />
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  methods: {
    scrollTo(el) {
      this.$scrollTo(el, 500, {
        easing: "ease",
        offset: -90,
        y: true,
        x: false
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.m-h-100 {
  min-height: 85vh;
}

.bg-perfil {
  background-image: url("./../../assets/images/licensed/perfil.jpg");
  background-position: center top;
  background-size: cover;
  background-repeat: no-repeat;
}

.btn-comece-agora {
  @media (max-width: 767px) {
    margin: 0 auto;
    display: block;
  }
}

@media (max-width: 767px) {
  .padding-section {
    padding: 60px 0;
  }
}
</style>
